import { Box } from "@raca2022/uikit";
import styled from "styled-components";
import Bg from "../../../../assets/img/Langding/FarmPanner.png";
export const Container = styled(Box)`
  width: 100%;
  position: relative;
  padding: 4vw;
  :after {
    width: calc(100% - 4vw);
    height: calc(100% - 4vw);
    background-image: url("${Bg}");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    border-radius: 20px;
    z-index: -1;
  }
  @media only screen and (min-width: 1920px) {
    padding: 80px;
    :after{
      width: calc(100% - 80px);
      height: calc(100% - 80px);
    }
  }
`;
export const Content = styled(Box)`
  width: 100%;
  padding: 4vw 7.5vw;
  display: flex;
  justify-content: space-between;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 20px;
  gap: 2.67%;
  div {
    width: 48.665%;
  }
  h1 {
    font-weight: 700;
    font-size: 50px;
    line-height: 110%;
    color: #144456;
    font-family: "PoppinsBold";
    margin-bottom: 25px;
  }
  button {
    box-shadow: 2px 4px 6px rgba(15, 46, 57, 0.23);
    border-radius: 10px;
    background: #009768;
    border: none;
    outline: none;
    font-weight: 600;
    font-size: 18px;
    line-height: 110%;
    font-family: PoppinsSemiBold;
    color: #fff;
    padding: 18px 52px;
    display: none;
  }
  div{
    button{
      display: block;
    }
  }
  p {
    font-weight: 500;
    font-size: 18px;
    line-height: 110%;
    color: #8094AE;
    font-family: 'PoppinsMedium';
    margin-bottom: 24px;
  }
  @media only screen and (min-width: 1920px) {
    padding: 90px 150px;
  }
  @media only screen and (max-width: 1024px){
    flex-direction: column;
    button{
      display: block;
      width: 206px;
      height: 57px;
      padding: 0px;
      margin: auto;
      margin-top: 30px;
    }
    div{
      width: 100%;
      button{
        display: none;
      }
    }
    h1{
      font-size: 3.53vw;
      width: 100%;
      text-align: center;
    }
    p{
      font-size: 2.8vw;
      text-align: center;
    }
  }
  @media only screen and (max-width: 430px){
    h1{
      font-size: 16px;
    }
    p{
      font-size: 12px;
    }
  }
`;
